import * as icons from "@/assets/icons";
import { motion, type MotionProps } from "framer-motion";

export interface IconProps extends MotionProps {
	name: keyof typeof icons;
	width?: number;
	height?: number;
	colors?: string[];
	motions?: MotionProps[];
	className?: string;
	viewBox?: string;
}

export const Icon = ({
	name,
	width = 24,
	height = 24,
	colors,
	motions,
	className,
	viewBox = "0 0 24 24",
	...props
}: IconProps) => {
	const paths = icons[name];

	return (
		<motion.svg
			width={width}
			height={height}
			viewBox={viewBox}
			fill="none"
			className={className}
			{...props}
		>
			{paths.map((path, i) => (
				<motion.path
					key={i}
					d={path.d}
					transform={path.transform}
					fill={colors?.[i] ?? "currentColor"}
					{...motions?.[i]}
				/>
			))}
		</motion.svg>
	);
};
